import React from 'react';
import { Grid, Typography, Divider, Tooltip, IconButton, Button, Box, Chip, Avatar, Tabs, Tab } from '@mui/material';
import moment from 'moment';

import EventIcon from '@mui/icons-material/Event';
import BusinessIcon from '@mui/icons-material/Business';
import AssigmentIcon from '@mui/icons-material/Assignment';
import DescriptionIcon from '@mui/icons-material/Description';
import ListAltIcon from '@mui/icons-material/ListAlt';
import ScheduleIcon from '@mui/icons-material/Schedule';
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useHistory } from 'react-router-dom';

// Icons for procedures
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import RefreshIcon from '@mui/icons-material/Refresh';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import CabecalhoInformacoes2 from './CabecalhoInformacoes2.js';
import CabecalhoInformacoes from './CabecalhoInformacoes.js';
import RequerimentoInsumos from './requerimentoInsumos.js';
import LogInterativo from './LogInterativo';

export default function EditorOrdemServicoModerno(props) {
    const {
        ordemServico, loading, themeHelper, darkMode, limiar, larguraOriginal, solicitacaoSelecionada,
        idEntradaEstoque, instalacaoSelecionada, projetoSelecionado, colaboradorSelecionado, propostaSelecionada,
        solicitante, analista, ped, rondaVirtual, ordemCompra, compra,

        handleOpenCronograma, handleClickAgendamento, handleClickListaItens, handleClickSaidaEstoque,
        setOpenTratamentoRemoto, novoProcedimento, handleClickIniciarProcedimento,
        handleClickOpenCancelarProcedimento, handleClickOpenRepassarProcedimento,
        handleClickAtualizarProcedimento, handleClickVizualizarProcedimento, handleClickOpenExcluirProcedimento,
    } = props;

    const history = useHistory();
    const [tabEtapa, setTabEtapa] = React.useState(0);

    if (!ordemServico || loading) return null;

    const getStatusLabel = (status) => {
        switch (status) {
            case 0: return "Aguardando Análise";
            case 1: return "Em Tratamento Remoto";
            case 2: return "Ag. Tratamento Remoto";
            case 3: return "Ag. Tratamento Campo";
            case 4: return "Aprovado";
            case 5: return "Reprovado";
            default: return "Desconhecido";
        }
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 0: case 1: return "info";
            case 2: return "warning";
            case 3: return "warning";
            case 4: return "success";
            case 5: return "error";
            default: return "default";
        }
    };

    const itensRequeridos = ordemServico.itens_pre_requerimento || ordemServico.itens_agendamento || [];
    const textoTooltipItens = itensRequeridos.length > 0
        ? itensRequeridos.map(i => {
            const nomeInsumo = i?.insumo?.nome || i?.nome_item || i?.nome || 'Item desconhecido';
            return `- ${nomeInsumo} (Qtd: ${i.quantidade || 1})`;
        }).join('\n')
        : "Nenhum item adicionado.";

    const renderProcedimentoButtons = (proc) => (
        <Box display="flex" gap={1} alignItems="center" mt={2}>
            {proc.status === 0 && proc.data_hora_inicio_execucao === null && (
                <Button
                    size="small"
                    variant="outlined"
                    color="success"
                    startIcon={<PlayCircleOutlineIcon />}
                    onClick={() => handleClickIniciarProcedimento(proc)}
                    style={{ borderRadius: '20px', textTransform: 'none' }}
                >
                    Iniciar
                </Button>
            )}

            {proc.status === 0 && proc.data_hora_inicio_execucao !== null && (
                <Button
                    size="small"
                    variant="outlined"
                    color="primary"
                    startIcon={<RefreshIcon />}
                    onClick={() => handleClickAtualizarProcedimento(proc)}
                    style={{ borderRadius: '20px', textTransform: 'none' }}
                >
                    Atualizar
                </Button>
            )}

            {proc.status === 1 && (
                <Button
                    size="small"
                    variant="outlined"
                    color="primary"
                    startIcon={<VisibilityOutlinedIcon />}
                    onClick={() => handleClickVizualizarProcedimento(proc.id_procedimento_execucao)}
                    style={{ borderRadius: '20px', textTransform: 'none' }}
                >
                    Visualizar
                </Button>
            )}

            <Box flex={1} /> {/* Spacer */}

            {proc.status === 0 && (
                <Tooltip title="Cancelar Procedimento">
                    <IconButton size="small" color="warning" onClick={() => handleClickOpenCancelarProcedimento(proc)}>
                        <CancelOutlinedIcon fontSize="small" />
                    </IconButton>
                </Tooltip>
            )}

            <Tooltip title="Excluir Procedimento">
                <IconButton size="small" color="error" onClick={() => handleClickOpenExcluirProcedimento(proc)}>
                    <DeleteOutlineIcon fontSize="small" />
                </IconButton>
            </Tooltip>
        </Box>
    );

    const renderProcedimentoDetails = (proc) => (
        <>
            <Typography variant="body2" style={{ color: themeHelper?.text, opacity: 0.7, marginTop: 4 }}>
                ID: {proc.id_procedimento_execucao} • Status: {proc.status === 0 ? "Não Executado" : "Concluído"}
            </Typography>
            {proc.usuario_criador && (
                <Typography variant="body2" style={{ color: themeHelper?.text, opacity: 0.7 }}>
                    Criador: {proc.usuario_criador.nome_amigavel}
                </Typography>
            )}
            {proc.usuario_executor && (
                <Typography variant="body2" style={{ color: themeHelper?.text, opacity: 0.7 }}>
                    Executor: {proc.usuario_executor.nome_amigavel}
                </Typography>
            )}
            {proc.status === 1 && (
                <>
                    <Typography variant="body2" style={{ color: themeHelper?.text, opacity: 0.7 }}>
                        Resultado: {proc.resultado === 0 ? "Falha" : "Sucesso"}
                    </Typography>
                    <Typography variant="body2" style={{ color: themeHelper?.text, opacity: 0.7 }}>
                        Executado em: {moment(proc.data_hora_execucao, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')}
                    </Typography>
                    <Typography variant="body2" style={{ color: themeHelper?.text, opacity: 0.7 }}>
                        Resumo: {proc.observacoes}
                    </Typography>
                </>
            )}
            <Typography variant="body2" style={{ color: themeHelper?.text, opacity: 0.7 }}>
                {proc.procedimento.obrigatorio === 1 ? "Procedimento Obrigatório" : "Procedimento Opcional"}
            </Typography>
        </>
    );

    return (
        <Grid container style={{ backgroundColor: themeHelper?.paper || '#fff', minHeight: '100vh', width: '100%', fontFamily: '"Inter", "Roboto", sans-serif' }}>

            {/* BARRA LATERAL (Clean Design - No Scroll) */}
            <Grid item xs={12} md={3} style={{
                borderRight: `1px solid ${darkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)'}`,
                padding: '20px 16px',
                position: larguraOriginal > 960 ? 'sticky' : 'static',
                top: 0,
                height: larguraOriginal > 960 ? '100vh' : 'auto',
                overflow: 'hidden',
                backgroundColor: darkMode ? '#121212' : '#fafafa',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between'
            }}>
                <Box>
                    <Box mb={2}>
                        <Box display="flex" alignItems="center" gap={1} mb={0.5}>
                            <Tooltip title="Voltar para Lista">
                                <IconButton size="small" onClick={() => history.push('/gestao/administracao/ordensdeservicos/listar')} style={{ padding: 4 }}>
                                    <ArrowBackIcon fontSize="small" style={{ color: themeHelper?.text, opacity: 0.6 }} />
                                </IconButton>
                            </Tooltip>
                            <Typography variant="overline" style={{ color: themeHelper?.text, opacity: 0.5, letterSpacing: 1.5, lineHeight: 1 }}>
                                O.S. #{ordemServico.id_ordem_servico}
                            </Typography>
                        </Box>
                        <Box mt={0.5}>
                            <Chip
                                label={getStatusLabel(ordemServico.status_ordem)}
                                color={getStatusColor(ordemServico.status_ordem)}
                                size="small"
                                variant="filled"
                                style={{ fontWeight: 600, borderRadius: '8px' }}
                            />
                        </Box>
                    </Box>

                    <Box mb={1.5} display="flex" alignItems="flex-start" gap={1.5}>
                        <Avatar style={{ width: 28, height: 28, backgroundColor: darkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.04)', color: themeHelper?.text }}>
                            <EventIcon style={{ fontSize: 16 }} />
                        </Avatar>
                        <Box>
                            <Typography variant="caption" style={{ color: themeHelper?.text, opacity: 0.6, textTransform: 'uppercase', lineHeight: 1 }}>Criação</Typography>
                            <Typography variant="body2" style={{ color: themeHelper?.text, fontWeight: 500, fontSize: '0.8rem', lineHeight: 1.2 }}>
                                {ordemServico.data_hora_criacao ? moment(ordemServico.data_hora_criacao).format('DD/MM/YYYY HH:mm') : 'N/D'}
                            </Typography>
                            <Typography variant="caption" style={{ color: themeHelper?.text, opacity: 0.6, fontSize: '0.7rem' }}>
                                {ordemServico.usuario_criador?.nome_amigavel || 'Sistema'}
                            </Typography>
                        </Box>
                    </Box>

                    {instalacaoSelecionada && (
                        <Box mb={1.5} display="flex" alignItems="flex-start" gap={1.5}>
                            <Avatar style={{ width: 28, height: 28, backgroundColor: darkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.04)', color: themeHelper?.text }}>
                                <BusinessIcon style={{ fontSize: 16 }} />
                            </Avatar>
                            <Box>
                                <Typography variant="caption" style={{ color: themeHelper?.text, opacity: 0.6, textTransform: 'uppercase', lineHeight: 1 }}>Instalação</Typography>
                                <Typography variant="body2" style={{ color: themeHelper?.text, fontWeight: 500, fontSize: '0.8rem', lineHeight: 1.2, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                                    {instalacaoSelecionada?.nome || instalacaoSelecionada?.nome_fantasia || "Não informada"}
                                </Typography>
                            </Box>
                        </Box>
                    )}

                    <Box mb={1.5} display="flex" alignItems="flex-start" gap={1.5}>
                        <Avatar style={{ width: 28, height: 28, backgroundColor: darkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.04)', color: themeHelper?.text }}>
                            <AssigmentIcon style={{ fontSize: 16 }} />
                        </Avatar>
                        <Box>
                            <Typography variant="caption" style={{ color: themeHelper?.text, opacity: 0.6, textTransform: 'uppercase', lineHeight: 1 }}>Solicitação</Typography>
                            <Typography variant="body2" style={{ color: themeHelper?.text, fontWeight: 500, fontSize: '0.8rem', lineHeight: 1.2, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                                {solicitacaoSelecionada?.solicitacao || 'N/D'}
                            </Typography>
                        </Box>
                    </Box>

                    <Box mb={1.5} display="flex" alignItems="flex-start" gap={1.5}>
                        <Avatar style={{ width: 28, height: 28, backgroundColor: darkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.04)', color: themeHelper?.text }}>
                            <DescriptionIcon style={{ fontSize: 16 }} />
                        </Avatar>
                        <Box>
                            <Typography variant="caption" style={{ color: themeHelper?.text, opacity: 0.6, textTransform: 'uppercase', lineHeight: 1 }}>Descrição</Typography>
                            <Typography variant="body2" style={{ color: themeHelper?.text, fontWeight: 500, fontSize: '0.8rem', lineHeight: 1.2, display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                                {ordemServico.descricao_solicitacao || 'Sem descrição'}
                            </Typography>
                        </Box>
                    </Box>

                    <Tooltip title={<span style={{ whiteSpace: 'pre-line' }}>{textoTooltipItens}</span>} placement="right" arrow>
                        <Box mb={1.5} display="flex" alignItems="flex-start" gap={1.5} style={{ cursor: 'pointer' }} onClick={handleClickListaItens}>
                            <Avatar style={{ width: 28, height: 28, backgroundColor: darkMode ? 'rgba(255,255,255,0.05)' : 'rgba(25,118,210,0.1)', color: '#1976d2' }}>
                                <ListAltIcon style={{ fontSize: 16 }} />
                            </Avatar>
                            <Box>
                                <Typography variant="caption" style={{ color: themeHelper?.text, opacity: 0.6, textTransform: 'uppercase', lineHeight: 1 }}>Itens Requeridos</Typography>
                                <Typography variant="body2" style={{ color: themeHelper?.text, fontWeight: 500, fontSize: '0.8rem', lineHeight: 1.2 }}>
                                    {itensRequeridos.length} item(s) listado(s)
                                </Typography>
                            </Box>
                        </Box>
                    </Tooltip>

                    <Box mb={1.5} display="flex" alignItems="flex-start" gap={1.5} style={{ cursor: 'pointer' }} onClick={handleClickAgendamento}>
                        <Avatar style={{ width: 28, height: 28, backgroundColor: darkMode ? 'rgba(255,255,255,0.05)' : 'rgba(237,108,2,0.1)', color: '#ed6c02' }}>
                            <ScheduleIcon style={{ fontSize: 16 }} />
                        </Avatar>
                        <Box>
                            <Typography variant="caption" style={{ color: themeHelper?.text, opacity: 0.6, textTransform: 'uppercase', lineHeight: 1 }}>Agendamento</Typography>
                            {ordemServico.agendamento ? (
                                <>
                                    <Typography variant="caption" display="block" style={{ color: themeHelper?.text, fontWeight: 500, fontSize: '0.75rem' }}>
                                        Início: {ordemServico.agendamento.data_hora_inicial ? moment(ordemServico.agendamento.data_hora_inicial).format('DD/MM HH:mm') : 'N/D'}
                                    </Typography>
                                    <Typography variant="caption" display="block" style={{ color: themeHelper?.text, fontWeight: 500, fontSize: '0.75rem' }}>
                                        Fim: {ordemServico.agendamento.data_hora_final ? moment(ordemServico.agendamento.data_hora_final).format('DD/MM HH:mm') : 'N/D'}
                                    </Typography>
                                    {ordemServico.agendamento.veiculo && (
                                        <Typography variant="caption" display="block" style={{ color: themeHelper?.text, fontWeight: 500, marginTop: 2, fontSize: '0.75rem' }}>
                                            🚙 {ordemServico.agendamento.veiculo.placa} ({ordemServico.agendamento.veiculo.modelo})
                                        </Typography>
                                    )}
                                    {ordemServico.agendamento.colaboradores && ordemServico.agendamento.colaboradores.map((colab, idx) => (
                                        <Typography key={idx} variant="caption" display="block" style={{ color: themeHelper?.text, fontWeight: 500, marginTop: 2, fontSize: '0.75rem' }}>
                                            👷‍♂️ {colab.colaborador ? colab.colaborador.nome_amigavel || `${colab.colaborador.nome} ${colab.colaborador.sobrenome}` : colab.nome_amigavel || `${colab.nome} ${colab.sobrenome}`}
                                            {colab.status === 9 ? ' (Retirado)' : ''}
                                        </Typography>
                                    ))}
                                </>
                            ) : (
                                <Typography variant="caption" display="block" style={{ color: themeHelper?.text, opacity: 0.5, fontStyle: 'italic', fontSize: '0.75rem' }}>
                                    Não agendado
                                </Typography>
                            )}
                        </Box>
                    </Box>

                    <Box mt={ordemServico.agendamento ? 1.5 : 0} display="flex" alignItems="flex-start" gap={1.5} style={{ cursor: 'pointer' }} onClick={(e) => handleOpenCronograma(e)}>
                        <Avatar style={{ width: 28, height: 28, backgroundColor: darkMode ? 'rgba(255,255,255,0.05)' : 'rgba(156,39,176,0.1)', color: '#9c27b0' }}>
                            <EventIcon style={{ fontSize: 16 }} />
                        </Avatar>
                        <Box>
                            <Typography variant="caption" style={{ color: themeHelper?.text, opacity: 0.6, textTransform: 'uppercase', lineHeight: 1 }}>Cronograma</Typography>
                            <Typography variant="caption" display="block" style={{ color: themeHelper?.text, fontWeight: 500, fontSize: '0.75rem' }}>
                                Ver Eventos e Datas
                            </Typography>
                        </Box>
                    </Box>
                    <Box mt={1.5} display="flex" alignItems="flex-start" gap={1.5} style={{ cursor: 'pointer' }} onClick={handleClickSaidaEstoque}>
                        <Avatar style={{ width: 28, height: 28, backgroundColor: darkMode ? 'rgba(255,255,255,0.05)' : 'rgba(76,175,80,0.1)', color: '#4caf50' }}>
                            <ListAltIcon style={{ fontSize: 16 }} />
                        </Avatar>
                        <Box>
                            <Typography variant="caption" style={{ color: themeHelper?.text, opacity: 0.6, textTransform: 'uppercase', lineHeight: 1 }}>Estoque</Typography>
                            <Typography variant="caption" display="block" style={{ color: themeHelper?.text, fontWeight: 500, fontSize: '0.75rem' }}>
                                Saída de Estoque
                            </Typography>
                        </Box>
                    </Box>
                </Box>

            </Grid>

            {/* CONTEÚDO PRINCIPAL (Overview sem TABS) */}
            <Grid item xs={12} md={9} style={{ padding: '24px', backgroundColor: themeHelper?.paper }}>


                <Box borderBottom={1} borderColor={darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'} mb={2}>
                    <Tabs
                        value={tabEtapa}
                        onChange={(e, newValue) => setTabEtapa(newValue)}
                        TabIndicatorProps={{ style: { backgroundColor: '#1976d2', height: 3, borderRadius: '3px 3px 0 0' } }}
                        style={{ minHeight: '40px' }}
                    >
                        <Tab label="Geral" style={{ textTransform: 'none', fontWeight: 600, fontSize: '0.85rem', minHeight: '40px', padding: '6px 16px', color: tabEtapa === 0 ? '#1976d2' : themeHelper?.text }} />
                        <Tab label="Tratamento Remoto" style={{ textTransform: 'none', fontWeight: 600, fontSize: '0.85rem', minHeight: '40px', padding: '6px 16px', color: tabEtapa === 1 ? '#1976d2' : themeHelper?.text }} />
                        <Tab label="Análise Prévia" style={{ textTransform: 'none', fontWeight: 600, fontSize: '0.85rem', minHeight: '40px', padding: '6px 16px', color: tabEtapa === 2 ? '#1976d2' : themeHelper?.text }} />
                        <Tab label="Tratamento em Campo" style={{ textTransform: 'none', fontWeight: 600, fontSize: '0.85rem', minHeight: '40px', padding: '6px 16px', color: tabEtapa === 3 ? '#1976d2' : themeHelper?.text }} />
                        <Tab label="Log Interativo" style={{ textTransform: 'none', fontWeight: 600, fontSize: '0.85rem', minHeight: '40px', padding: '6px 16px', color: tabEtapa === 4 ? '#1976d2' : themeHelper?.text }} />
                    </Tabs>
                </Box>

                {tabEtapa === 0 && (
                    <Box style={{ animation: 'fadeIn 0.3s ease-in-out' }}>

                        <Box mb={4} style={{
                            backgroundColor: darkMode ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.01)',
                            borderRadius: '16px',
                            padding: '20px',
                        }}>
                            {ordemServico.solicitacao?.id_solicitacao === 7 ? (
                                <CabecalhoInformacoes
                                    ordemServico={ordemServico}
                                    instalacaoSelecionada={instalacaoSelecionada}
                                    projetoSelecionado={projetoSelecionado}
                                    colaboradorSelecionado={colaboradorSelecionado}
                                    propostaSelecionada={propostaSelecionada}
                                    solicitacaoSelecionada={solicitacaoSelecionada}
                                    solicitante={solicitante}
                                    analista={analista}
                                    ped={ped}
                                    rondaVirtual={rondaVirtual}
                                />
                            ) : (
                                <CabecalhoInformacoes2
                                    ordemServico={ordemServico}
                                    instalacaoSelecionada={instalacaoSelecionada}
                                    projetoSelecionado={projetoSelecionado}
                                    propostaSelecionada={propostaSelecionada}
                                    solicitacaoSelecionada={solicitacaoSelecionada}
                                    solicitante={solicitante}
                                    analista={analista}
                                    rondaVirtual={rondaVirtual}
                                    ped={ped}
                                    ordemCompra={ordemCompra}
                                    compra={compra}
                                />
                            )}
                        </Box>

                        {ordemServico.solicitacao?.id_solicitacao === 7 && (
                            <Box mb={4}>
                                <Typography variant="h6" style={{ color: themeHelper?.text, marginBottom: '16px', fontWeight: 500 }}>
                                    Requerimento de Insumos
                                </Typography>
                                <RequerimentoInsumos flag={0} ordemServicoIn={ordemServico} />
                            </Box>
                        )}
                    </Box>
                )}

                {/* Tratamento Remoto */}
                {tabEtapa === 1 && (
                    <Box mb={4} style={{ animation: 'fadeIn 0.3s ease-in-out' }}>
                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                            <Typography variant="h6" style={{ color: themeHelper?.text, fontWeight: 500 }}>
                                Procedimentos de Tratamento Remoto
                            </Typography>
                            {ordemServico.status_ordem === 1 ? (
                                <Box display="flex" gap={1}>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        size="small"
                                        startIcon={<AddIcon />}
                                        style={{ borderRadius: '20px', textTransform: 'none', fontWeight: 600 }}
                                        onClick={() => novoProcedimento(1)}
                                    >
                                        + Procedimento
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        style={{ borderRadius: '20px', textTransform: 'none' }}
                                        onClick={() => setOpenTratamentoRemoto(true)}
                                    >
                                        Finalizar Remoto
                                    </Button>
                                </Box>
                            ) : (
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    startIcon={<AddIcon />}
                                    style={{ borderRadius: '20px', textTransform: 'none', fontWeight: 600 }}
                                    onClick={() => novoProcedimento(1)}
                                >
                                    + Procedimento
                                </Button>
                            )}
                        </Box>

                        <Grid container spacing={3}>
                            {ordemServico.procedimentos_tratamento_remoto?.length > 0 ? ordemServico.procedimentos_tratamento_remoto.map((proc, index) => (
                                <Grid item xs={12} md={6} key={index}>
                                    <Box p={3} style={{
                                        backgroundColor: darkMode ? 'rgba(255,255,255,0.02)' : '#ffffff',
                                        borderRadius: '16px',
                                        border: `1px solid ${darkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)'}`,
                                        boxShadow: darkMode ? 'none' : '0 4px 24px rgba(0,0,0,0.02)'
                                    }}>
                                        <Typography variant="subtitle1" style={{ color: themeHelper?.text, fontWeight: 600 }}>
                                            {proc.procedimento.nome}
                                        </Typography>

                                        {renderProcedimentoDetails(proc)}
                                        <Divider style={{ margin: '12px 0', opacity: 0.5 }} />
                                        {renderProcedimentoButtons(proc)}

                                    </Box>
                                </Grid>
                            )) : (
                                <Grid item xs={12}>
                                    <Typography variant="body2" style={{ color: themeHelper?.text, opacity: 0.5, fontStyle: 'italic' }}>
                                        Nenhum procedimento remoto registrado.
                                    </Typography>
                                </Grid>
                            )}
                        </Grid>
                    </Box>
                )}

                {/* Análise Prévia */}
                {tabEtapa === 2 && (
                    <Box mb={4} style={{ animation: 'fadeIn 0.3s ease-in-out' }}>
                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                            <Typography variant="h6" style={{ color: themeHelper?.text, fontWeight: 500 }}>
                                Procedimentos de Análise Prévia
                            </Typography>
                            <Button
                                variant="outlined"
                                color="primary"
                                size="small"
                                startIcon={<AddIcon />}
                                style={{ borderRadius: '20px', textTransform: 'none', fontWeight: 600 }}
                                onClick={() => novoProcedimento(2)}
                            >
                                + Procedimento
                            </Button>
                        </Box>

                        <Grid container spacing={3}>
                            {ordemServico.procedimentos_analise?.length > 0 ? ordemServico.procedimentos_analise.map((proc, index) => (
                                <Grid item xs={12} md={6} key={index}>
                                    <Box p={3} style={{
                                        backgroundColor: darkMode ? 'rgba(255,255,255,0.02)' : '#ffffff',
                                        borderRadius: '16px',
                                        border: `1px solid ${darkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)'}`,
                                        boxShadow: darkMode ? 'none' : '0 4px 24px rgba(0,0,0,0.02)'
                                    }}>
                                        <Typography variant="subtitle1" style={{ color: themeHelper?.text, fontWeight: 600 }}>
                                            {proc.procedimento?.nome || 'Procedimento sem nome'}
                                        </Typography>

                                        {renderProcedimentoDetails(proc)}
                                        <Divider style={{ margin: '12px 0', opacity: 0.5 }} />
                                        {renderProcedimentoButtons(proc)}

                                    </Box>
                                </Grid>
                            )) : (
                                <Grid item xs={12}>
                                    <Typography variant="body2" style={{ color: themeHelper?.text, opacity: 0.5, fontStyle: 'italic' }}>
                                        Nenhum procedimento de análise registrado.
                                    </Typography>
                                </Grid>
                            )}
                        </Grid>
                    </Box>
                )}

                {/* Tratamento Em Campo */}
                {tabEtapa === 3 && (
                    <Box mb={5} pb={4} style={{ animation: 'fadeIn 0.3s ease-in-out' }}>
                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                            <Typography variant="h6" style={{ color: themeHelper?.text, fontWeight: 500 }}>
                                Procedimentos de Tratamento em Campo
                            </Typography>
                            {ordemServico.status_ordem === 3 ? (
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    startIcon={<AddIcon />}
                                    style={{ borderRadius: '20px', textTransform: 'none', fontWeight: 600 }}
                                    onClick={() => novoProcedimento(3)}
                                >
                                    + Procedimento
                                </Button>
                            ) : (
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    startIcon={<AddIcon />}
                                    style={{ borderRadius: '20px', textTransform: 'none', fontWeight: 600 }}
                                    onClick={() => novoProcedimento(3)}
                                >
                                    + Procedimento
                                </Button>
                            )}
                        </Box>

                        <Grid container spacing={3}>
                            {ordemServico.procedimentos_tratamento_em_campo?.length > 0 ? ordemServico.procedimentos_tratamento_em_campo.map((proc, index) => (
                                <Grid item xs={12} md={6} key={index}>
                                    <Box p={3} style={{
                                        backgroundColor: darkMode ? 'rgba(255,255,255,0.02)' : '#ffffff',
                                        borderRadius: '16px',
                                        border: `1px solid ${darkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)'}`,
                                        boxShadow: darkMode ? 'none' : '0 4px 24px rgba(0,0,0,0.02)'
                                    }}>
                                        <Typography variant="subtitle1" style={{ color: themeHelper?.text, fontWeight: 600 }}>
                                            {proc.procedimento?.nome || 'Procedimento sem nome'}
                                        </Typography>

                                        {renderProcedimentoDetails(proc)}
                                        <Divider style={{ margin: '12px 0', opacity: 0.5 }} />
                                        {renderProcedimentoButtons(proc)}

                                    </Box>
                                </Grid>
                            )) : (
                                <Grid item xs={12}>
                                    <Typography variant="body2" style={{ color: themeHelper?.text, opacity: 0.5, fontStyle: 'italic' }}>
                                        Nenhum procedimento de campo registrado.
                                    </Typography>
                                </Grid>
                            )}
                        </Grid>
                    </Box>
                )}

                {/* Log Interativo */}
                {tabEtapa === 4 && (
                    <Box mb={5} pb={4} style={{ animation: 'fadeIn 0.3s ease-in-out', height: '100%' }}>
                         <Typography variant="h6" style={{ color: themeHelper?.text, fontWeight: 500, marginBottom: '16px' }}>
                            Acompanhamento e Histórico
                        </Typography>
                        <LogInterativo ordemId={ordemServico.id_ordem_servico} darkMode={darkMode} themeHelper={themeHelper} />
                    </Box>
                )}
            </Grid>
        </Grid>
    );
}
